import { render, staticRenderFns } from "./AcceptCancelsModal.vue?vue&type=template&id=ed6768a2"
import script from "./AcceptCancelsModal.vue?vue&type=script&lang=js"
export * from "./AcceptCancelsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports